import React from 'react';
import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from '@mui/material';

export interface ButtonProps extends MuiButtonProps {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, startIcon, endIcon, ...props }, ref) => {
    return (
      <MuiButton ref={ref} startIcon={startIcon} endIcon={endIcon} {...props}>
        {children}
      </MuiButton>
    );
  },
);

Button.displayName = 'Button';

export default Button;
